import * as Yup from "yup";

export const convertDateStrings = (dateString: string): string => {
  const toDate = new Date(dateString);
  const stringDate = toDate.toISOString();
  const date = String(stringDate).slice(0, 10);
  const time = String(stringDate).slice(11, 16);
  return `${date} ${time}`;
};

export const handleTableTime = (string: string): string => {
  const initalTime = new Date(string);
  const updatedTime = new Date(initalTime.setHours(initalTime.getHours() + 1));
  const year = String(updatedTime).slice(11, 15);
  const day = String(updatedTime).slice(8, 10);
  const month = handleMonth(String(updatedTime).slice(4, 7));
  const time = String(updatedTime).slice(16, 21);

  return `${year}-${month}-${day} ${time}`;
};

export const handleHourMismatch = (
  dateString: string,
  addHour: number = 1
): string => {
  console.log("checking date string " + dateString);
  const initalTime = new Date(dateString);
  const updatedTime = new Date(
    initalTime.setHours(initalTime.getHours() + addHour)
  );
  console.log("checking updated time + ", updatedTime);
  return updatedTime.toISOString();
};

export const notificationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "More than 1 character required")
    .max(50, "Too many characters")
    .required("Required"),
  title: Yup.string()
    .min(2, "More than 1 character rquired")
    .max(50, "Too many characters")
    .required("Required"),
  body: Yup.string().max(100, "Too many characters"),
  deeplink: Yup.string().max(50, "Too many characters"),
  throttleRate: Yup.number()
    .positive("Throttle rate must be positive")
    .integer("Integer values only"),
  pauseSendingTime: Yup.string().matches(
    /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/,
    "hh:mm:ss format required"
  ),
  resumeSendingTime: Yup.string().matches(
    /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/,
    "hh:mm:ss format required"
  ),
  application: Yup.string()
    .matches(/(TRAVELAPP)/, "TRAVELAPP only valid string")
    .length(9, "TRAVELAPP only valid string"),
});

const handleMonth = (month: string): string => {
  switch (month.toLowerCase()) {
    case "jan":
      return "01";
    case "feb":
      return "02";
    case "mar":
      return "03";
    case "apr":
      return "04";
    case "may":
      return "05";
    case "jun":
      return "06";
    case "jul":
      return "07";
    case "aug":
      return "08";
    case "sep":
      return "09";
    case "oct":
      return "10";
    case "nov":
      return "11";
    case "dec":
      return "12";
  }
};
